import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;
const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  const knownBuild = useRef(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`${API}/api/version`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const build = data.build;

        if (knownBuild.current === null) {
          knownBuild.current = build;
          return;
        }

        if (build !== knownBuild.current) {
          toast.info('A new version is available. Please refresh to get the latest updates.', {
            duration: Infinity,
            action: {
              label: 'Refresh Now',
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch {
        // Silently ignore network errors
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);
}
